import { partnerCommissionPeriodAdminDTOSchema, partnerCommissionSettlementDTOSchema, partnerCustomerDTOSchema, partnerDTOSchema, partnerMemberDTOSchema, tenantPartnerDTOSchema, tenantPartnerResponseSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const listPartnersSchema = listEnvelopeSchema(partnerDTOSchema);
const singlePartnerSchema = dataEnvelopeSchema(partnerDTOSchema);
const listPartnerCustomersSchema = listEnvelopeSchema(partnerCustomerDTOSchema);
const singlePartnerCustomerSchema = dataEnvelopeSchema(partnerCustomerDTOSchema);
const singlePartnerMemberSchema = dataEnvelopeSchema(partnerMemberDTOSchema);
const listCommissionPeriodsSchema = listEnvelopeSchema(partnerCommissionPeriodAdminDTOSchema);
const commissionSettlementSchema = dataEnvelopeSchema(partnerCommissionSettlementDTOSchema);
const tenantPartnerResponseEnvelopeSchema = dataEnvelopeSchema(tenantPartnerResponseSchema);
const tenantPartnerEnvelopeSchema = dataEnvelopeSchema(tenantPartnerDTOSchema);
const PARTNERS_PATH = `${WEB_API_PREFIX}/partners`;
const TENANT_PARTNER_PATH = `${WEB_API_PREFIX}/tenant/partner`;
function partnerPath(partnerId) {
    return `${PARTNERS_PATH}/${encodeURIComponent(partnerId)}`;
}
export function createPartnersResource(transport) {
    return {
        async list(params = {}) {
            return transport.request({
                path: PARTNERS_PATH,
                schema: listPartnersSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async get(partnerId) {
            const envelope = await transport.request({ path: partnerPath(partnerId), schema: singlePartnerSchema });
            return envelope.data;
        },
        async create(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: PARTNERS_PATH,
                schema: singlePartnerSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(partnerId) {
            await transport.request({ method: 'DELETE', path: partnerPath(partnerId), schema: z.undefined() });
        },
        async listCustomers(partnerId, params = {}) {
            return transport.request({
                path: `${partnerPath(partnerId)}/customers`,
                schema: listPartnerCustomersSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async linkCustomer(partnerId, input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${partnerPath(partnerId)}/customers`,
                schema: singlePartnerCustomerSchema,
                body: input,
            });
            return envelope.data;
        },
        async unlinkCustomer(partnerId, tenantId) {
            await transport.request({
                method: 'DELETE',
                path: `${partnerPath(partnerId)}/customers/${encodeURIComponent(tenantId)}`,
                schema: z.undefined(),
            });
        },
        async inviteOwner(partnerId, input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${partnerPath(partnerId)}/members`,
                schema: singlePartnerMemberSchema,
                body: input,
            });
            return envelope.data;
        },
        async updateTerms(partnerId, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: partnerPath(partnerId),
                schema: singlePartnerSchema,
                body: input,
            });
            return envelope.data;
        },
        async listCommissionPeriods(partnerId, params = {}) {
            return transport.request({
                path: `${partnerPath(partnerId)}/commission-periods`,
                schema: listCommissionPeriodsSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async settleCommission(partnerId, input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${partnerPath(partnerId)}/commission-settlements`,
                schema: commissionSettlementSchema,
                body: input,
            });
            return envelope.data;
        },
    };
}
export function createTenantPartnerResource(transport) {
    return {
        async get() {
            const envelope = await transport.request({
                path: TENANT_PARTNER_PATH,
                schema: tenantPartnerResponseEnvelopeSchema,
            });
            return envelope.data;
        },
        async updateSetupAccess(input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: TENANT_PARTNER_PATH,
                schema: tenantPartnerEnvelopeSchema,
                body: input,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=partners.js.map